'use strict';

const BasePresenter = require('./base');

class SectionMapPresenter extends BasePresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    const isZoomedIn = this.model.get('isSectionMapZoomedIn');

    return { isZoomedIn };
  }
}

module.exports = SectionMapPresenter;
